"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADMIN_SYSTEM_GENERATED_WRITABLE_FIELDS = exports.ADMIN_ORGANIZATION_RUN_ENVIRONMENT_WRITABLE_FIELDS = exports.UserOrganizationRole = exports.customerBoundaryDbMap = exports.PROVISIONABLE_BOUNDARY_KINDS = exports.BoundaryKind = void 0;
var BoundaryKind;
(function (BoundaryKind) {
    BoundaryKind["GCP"] = "GCP";
    BoundaryKind["AWS"] = "AWS";
    BoundaryKind["OnPrem"] = "OnPrem";
})(BoundaryKind || (exports.BoundaryKind = BoundaryKind = {}));
exports.PROVISIONABLE_BOUNDARY_KINDS = [
    BoundaryKind.GCP,
    BoundaryKind.AWS,
];
exports.customerBoundaryDbMap = {
    id: "cb.id",
    provisionedAt: "cb.provisioned_at",
    claimedAt: "ocb.created_at",
    claimedOrganizationId: "ocb.organization_id",
    claimedUserId: "ocb.claimed_user_id",
    revokedAt: "ocb.revoked_at",
    cloudVendor: "cb.cloud_vendor",
    gcpProjectId: "cb.gcp_project_id",
};
var UserOrganizationRole;
(function (UserOrganizationRole) {
    UserOrganizationRole["OrganizationAdmin"] = "org_admin";
    UserOrganizationRole["Member"] = "member";
})(UserOrganizationRole || (exports.UserOrganizationRole = UserOrganizationRole = {}));
exports.ADMIN_ORGANIZATION_RUN_ENVIRONMENT_WRITABLE_FIELDS = [
    "name",
    "executor",
    "containerType",
    "containerOptions",
    "runCommand",
    "nextTime",
    "nextQueue",
    "nextCpu",
    "nextMemory",
    "nextCluOpt",
    "executorJob",
    "jobTime",
    "jobQueue",
    "jobCpu",
    "jobMemory",
    "jobCluOpt",
    "username",
    "hostname",
    "nextPath",
    "port",
    "proxy",
    "singuCache",
    "variable",
    "bashVariable",
    "sshId",
    "autoWorkdir",
    "amazonCreId",
    "googleCreId",
    "hideWorkdir",
    "defNextflowWorkdir",
    "defWorkdir",
    "defPublishdir",
    "defDowndir",
    "spotInstance",
    "awsUseInstanceRole",
    "checkInitExec",
    "initJobCluOpt",
    "initJobTime",
    "initJobCpu",
    "initJobMemory",
    "initJobQueue",
    "region",
    "projectId",
    "execJobMaxMemory",
    "execJobMaxCpu",
];
exports.ADMIN_SYSTEM_GENERATED_WRITABLE_FIELDS = [
    "amazonCreId",
    "awsUseInstanceRole",
];
